import React from 'react';
import { Switch, Route } from 'react-router-dom';

// pages
import Create from './Create';
import List from './List';
import Info from './Info';

class Service extends React.PureComponent {
    render() {
        return (
            <Switch>
                <Route exact path='/product/create' component={Create} />
                <Route exact path='/product/list' component={List} />
                <Route exact path='/product/info' component={Info} />
            </Switch>
        );
    }
}
export default Service;
